namespace RioERP.Masters {
    export interface SmtpSettingsForm {
        ServerAddress: Serenity.StringEditor;
        FromName: Serenity.StringEditor;
        FromEmail: Serenity.StringEditor;
        UserName: Serenity.StringEditor;
        Password: Serenity.StringEditor;
        Port: Serenity.IntegerEditor;
        IsAws: Serenity.BooleanEditor;
        SendEmailOnWebsiteSync: Serenity.BooleanEditor;
        UseApi: Serenity.BooleanEditor;
        ApiProvider: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
    }

    export class SmtpSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.SmtpSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SmtpSettingsForm.init)  {
                SmtpSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(SmtpSettingsForm, [
                    'ServerAddress', w0,
                    'FromName', w0,
                    'FromEmail', w0,
                    'UserName', w0,
                    'Password', w0,
                    'Port', w1,
                    'IsAws', w2,
                    'SendEmailOnWebsiteSync', w2,
                    'UseApi', w2,
                    'ApiProvider', w0,
                    'ApiKey', w0
                ]);
            }
        }
    }
}
